module.exports = __webpack_public_path__ + "static/media/freezvix-5.172605dd.jpg";